import React from 'react';

const Pricing = () => {
  const plans = [
    {
      name: "Starter",
      description: "Essential AI customer service for small businesses",
      setupPrice: "$299",
      monthlyPrice: "$59",
      features: [
        "Website chat",
        "Knowledge base setup",
        "Appointment booking",
        "Email alerts",
        "Monthly reports",
        "Email support"
      ],
      featured: false
    },
    {
      name: "Professional", 
      description: "Advanced automation for growing businesses",
      setupPrice: "$699",
      monthlyPrice: "$140",
      features: [
        "Everything in Starter",
        "WhatsApp, Instagram, Telegram",
        "Advanced workflows",
        "Lead qualification",
        "CRM integration (Salesforce, HubSpot, Zoho)",
        "Custom branding",
        "Priority support",
        "Weekly optimization"
      ],
      featured: true
    },
    {
      name: "Enterprise",
      description: "Custom solutions for complex requirements",
      setupPrice: "Custom",
      monthlyPrice: "Custom", 
      features: [
        "Everything in Professional",
        "Unlimited complexity",
        "Custom integrations",
        "Advanced AI training",
        "Real-time dashboard"
      ],
      featured: false
    }
  ];

  return (
    <section id="pricing" className="section pricing-section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Simple, transparent pricing</h2>
          <p className="section-subtitle">
            No hidden fees. No long-term contracts. Cancel anytime. 
            All plans include free consultation and 30-day money-back guarantee.
          </p>
          
        </div>
        <div className="pricing-grid">
          {plans.map((plan, index) => (
            <div key={index} className={`pricing-card ${plan.featured ? 'featured' : ''}`}>
              <div className="pricing-header">
                <h3>{plan.name}</h3>
                <p>{plan.description}</p>
              </div>
              
              <div className="pricing-price">
                <div className="price-setup">{plan.setupPrice}</div>
                <div className="price-label">setup fee</div>
                <div className="price-monthly">{plan.monthlyPrice}</div>
                <div className="price-label">monthly support & maintenance (optional)</div>
                <div style={{ marginTop: '1rem', padding: '0.75rem', background: 'rgba(74, 144, 226, 0.1)', borderRadius: '8px', fontSize: '0.875rem', color: 'var(--text-secondary)', lineHeight: '1.5' }}>
                  <strong>AI Usage</strong>: Billed directly to your API accounts
                </div>
              </div>
              
              <ul className="pricing-features">
                {plan.features.map((feature, idx) => (
                  <li key={idx}>{feature}</li>
                ))}
              </ul>
              
              <a 
                href="https://calendly.com/dimitrovovich"
                target="_blank"
                rel="noopener noreferrer"
                className={`btn ${plan.featured ? 'btn-primary' : 'btn-secondary'}`}
                style={{ width: '100%', textAlign: 'center', justifyContent: 'center' }}
              >
                {plan.setupPrice === "Custom" ? "Contact Sales" : "Get Started"}
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Pricing;